import { inject } from '@angular/core'
import { CanDeactivateFn } from '@angular/router'
import { UnsavedChangesMessage } from '@ui-ui/unsaved-changes-message/unsaved-changes-message'
import { DialogService } from 'primeng/dynamicdialog'
import { Observable, Observer, Subject, takeUntil } from 'rxjs'

interface CanComponentDeactivate {
    canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean
    leaveMessage: () => string
}

export const canDeactivateGuard: CanDeactivateFn<CanComponentDeactivate> = (component: CanComponentDeactivate) => {
    const unsubscribe$ = new Subject<void>()
    const dialogService = inject(DialogService)

    if (!component || (component.canDeactivate && component.canDeactivate())) {
        return true
    }

    return new Observable((observer: Observer<boolean>) => {
        const message = component.leaveMessage && component.leaveMessage() ? component.leaveMessage() : ''
        const ref = dialogService.open(UnsavedChangesMessage, {
            baseZIndex: 10000,
            maximizable: true,
            contentStyle: { overflow: 'auto' },
            data: { message: message },
            header: 'Unsaved Changes',
            styleClass: 'unsaved-change',
            modal: true
        })

        ref?.onClose.pipe(takeUntil(unsubscribe$)).subscribe((action) => {
            observer.next(action === undefined ? false : action)
            observer.complete()

            unsubscribe$.next()
            unsubscribe$.complete()
        })
    })
}
